package com.parmartechnologies.core.feature.order.network

import com.parmartechnologies.core.feature.address.model.Address
import com.parmartechnologies.core.feature.cart.model.CartItem
import com.parmartechnologies.core.feature.order.reason.OrderReason
import com.parmartechnologies.core.feature.order.status.OrderStatus
import com.parmartechnologies.core.feature.product.model.ProductPrice
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

@Serializable
data class CreateOrderRequest @OptIn(ExperimentalTime::class) constructor(
    @SerialName("order_id") var orderId: Long = Clock.System.now().epochSeconds,
    @SerialName("user_id") var UserID: String = "",
    @SerialName("business_id") var BusinessID: String = "",
    @SerialName("store_id") var storeId: String = "",
    @SerialName("selected_business_id") var selectedBusinessID: String = "",
    @SerialName("address") var address: Address = Address(),
    @SerialName("device_id") var deviceId: String = "",
    @SerialName("order_items") var orderItems: ArrayList<CartItem> = arrayListOf(),
    @SerialName("pricing") var pricing: ProductPrice = ProductPrice(),
    @SerialName("DeliveryType") var deliveryType: String = "",
    @SerialName("instant_discount") var instantDiscount: Double = 0.0,
    @SerialName("coupon") var coupon: Double = 0.0,
)

@Serializable
data class RetrieveOrderRequest(
    @SerialName("user_id") var UserID: String = "",
    @SerialName("business_id") var BusinessID: String = "",
    @SerialName("store_id") var storeId: String = "",
    @SerialName("selected_business_id") var selectedBusinessID: String = "",
)

@Serializable
data class UpdateOrderRequest(
    @SerialName("_id") var _id: String = "",
    @SerialName("user_id") var UserID: String = "",
    @SerialName("business_id") var BusinessID: String = "",
    @SerialName("store_id") var storeId: String = "",
    @SerialName("selected_business_id") var selectedBusinessID: String = "",
    @SerialName("status") var status: OrderStatus? = null,
    @SerialName("reason") var reason: OrderReason? = null,
    @SerialName("reason_description") var reasonDescription: String? = "",
)